module.exports = __webpack_public_path__ + "img/slide-market-car.c8cbca7f.png";